import { Avatar, Badge, Button } from "flowbite-react";
import { MdVerified } from "react-icons/md";
import { HiPlay, HiPause } from 'react-icons/hi';
import Status from "./Status";
import { useState } from "react";
import { pauseConversation, resumeConversation } from "../../../api/conversations";
import toast from "react-hot-toast";

const Head = ({ lookalike, campaignInfluencer, campaign, conversation, followUp }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [isPaused, setIsPaused] = useState(conversation?.paused);

  const togglePauseConversation = async () => {
    setIsProcessing(true);

    try {
      if (isPaused === true) {
        await resumeConversation({
          id: conversation._id,
        });

        toast.success('Conversation resumed successfully');
      }
      else {
        await pauseConversation({
          id: conversation._id,
        });

        toast.success('Conversation paused successfully');
      }

      setIsPaused(!isPaused);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'Failed to set conversation status');
    } finally {
      setIsProcessing(false);
    }
  }

  const timeAgo = (timestamp) => {
    const now = new Date();
    const timeDiff = timestamp - now;
    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''}, ${hours % 24} hour${hours % 24 !== 1 ? 's' : ''}, ${minutes % 60} minute${minutes % 60 !== 1 ? 's' : ''}`;
    } else if (hours > 0) {
      return `${hours} hour${hours !== 1 ? 's' : ''}, ${minutes % 60} minute${minutes % 60 !== 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''}, ${seconds % 60} second${seconds % 60 !== 1 ? 's' : ''}`;
    } else {
      return `${seconds} second${seconds !== 1 ? 's' : ''}`;
    }
  }

  console.log(followUp);

  return (
    <div className="border-b border-gray-200 bg-white px-4 py-2.5 pb-4 sm:pb-2.5 dark:border-gray-700 dark:bg-gray-800">
      <div className="flex w-full items-center justify-between mb-2.5 sm:mb-0">
        <div className="flex gap-4 justify-between items-center">
          <a
            href={`https://instagram.com/${lookalike.profile.username}`}
            className="flex gap-2 items-center"
            target="_blank"
            rel="noreferrer"
          >
            <Avatar img={lookalike.profile.picture} rounded />
            <div>
              <div className="text-gray-900 flex gap-1 items-center">
                {lookalike.profile.fullname}
                {lookalike.profile.isVerified && <MdVerified color="#3b82f6" />}
              </div>
              <div className="text-xs mt-1 text-gray-500">@{lookalike.profile.username}</div>
            </div>
          </a>
          <Status status={campaignInfluencer.status} />
          {followUp?.timestamp && ((followUp.timestamp + followUp.delay) > new Date()) && (
            <div className="text-xs">Next follow up in {timeAgo(followUp.timestamp + followUp.delay)}</div>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-end gap-2 text-xs text-gray-500">
            <div className="flex gap-2 items-center">
              Campaign:
              <Badge color="gray">{campaign?.name}</Badge>
            </div>
            <div className="flex gap-2 items-center">
              <Button
                size="xs"
                className="mr-2"
                onClick={togglePauseConversation}
                disabled={isProcessing}
                isProcessing={isProcessing}
              >
                {isPaused === true ? <HiPlay className="size-5" /> : <HiPause className="size-5" />}
              </Button>
              Brand:
              <Badge color="gray">{campaign?.brandId?.name}</Badge>
            </div>
            {/* {channel && (
              <div className="flex gap-2 items-center">
                Channel:
                <Badge color="gray">Channel</Badge>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Head;